module.exports = __webpack_public_path__ + "img/leavsMobile.eb73e27b.png";